<template>
  <div class="publicityDetailWrapper">
    <div class="textBox">
      <Detail5 v-if="type === 5"/>
      <Detail4 v-else-if="type === 4"/>
      <Detail3 v-else-if="type === 3"/>
      <Detail2 v-else-if="type === 2"/>
      <Detail1 v-else/>
    </div>
    <Footer/>
  </div>
</template>

<script>
import Detail1 from './detail1';
import Detail2 from './detail2';
import Detail3 from './detail3';
import Detail4 from './detail4';
import Detail5 from './detail5';
import Footer from '../components/Footer';

export default {
  name: 'PublicityDetail',
  components: {
    Detail1,
    Detail2,
    Detail3,
    Detail4,
    Detail5,
    Footer
  },
  watch: {
    $route: {
      handler(val) {
        const { type } = val.query || {}
        this.type = Number.parseInt(type)
      },
      deep: true,
    },
  },
  data() {
    const { type } = this.$route.query || {}
    return {
      type: Number.parseInt(type)
    };
  }
};
</script>

<style scoped lang="less">
.publicityDetailWrapper {
  width: 100%;

  .textBox {
    margin: 30px 15%;
    padding: 30px 60px 30px;
    box-sizing: border-box;
    box-shadow: 0px 5px 5px 5px #eee;
    text-align: left;
  }
}
</style>
